// Relative cost and availability tiers for shopping suggestions.
//
// PRODUCT ASSUMPTION, not price data: tiers reflect typical US supermarket pricing per recipe
// quantity and how widely an item is stocked. They only order suggestions ("buy a lime" before
// "buy salmon"); the app never shows a price from them. Replace with real price data when a
// reliable source is connected.

import type { IngredientId } from './taxonomy';

/** 1 = inexpensive and stocked everywhere, 2 = moderate, 3 = pricier or less common. */
export type CostTier = 1 | 2 | 3;

const TIER_1: IngredientId[] = [
  'eggs', 'milk', 'onion', 'red_onion', 'garlic', 'carrots', 'potatoes', 'cabbage', 'celery', 'bananas',
  'apples', 'lemon', 'lime', 'tomatoes', 'cucumber', 'scallions', 'cilantro', 'lettuce', 'spinach',
  'baby_spinach', 'rice', 'white_rice', 'pasta', 'spaghetti', 'bread', 'flour', 'oats', 'flour_tortillas',
  'corn_tortillas', 'black_beans', 'chickpeas', 'lentils', 'frozen_peas', 'frozen_mixed_vegetables', 'peas',
  'tomato_paste', 'tomato_sauce', 'salt', 'sugar', 'cooking_oil', 'vinegar', 'soy_sauce', 'ketchup', 'mustard',
  'tuna', 'butter', 'yogurt', 'ginger', 'corn', 'green_beans', 'sweet_potatoes', 'cornstarch', 'baking_powder',
];
const TIER_3: IngredientId[] = [
  'salmon', 'shrimp', 'steak', 'white_fish', 'parmesan', 'feta', 'almonds', 'walnuts', 'heavy_cream',
  'fresh_basil', 'sesame_oil', 'blueberries', 'strawberries', 'quinoa', 'wine', 'beer',
];

export function costTier(id: IngredientId): CostTier {
  if (TIER_1.includes(id)) return 1;
  if (TIER_3.includes(id)) return 3;
  return 2;
}

/** Sum of tiers: a rough "how much extra will this cost" ordering key. */
export function missingCost(ids: IngredientId[]): number {
  return ids.reduce((sum, id) => sum + costTier(id), 0);
}
